// @ts-check

/** @file Defines the local Board shell and associations. */

import BoardBase from "../model-bases/board.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Board row in the local application replica. */
const BoardModel = projectReplicaModel(BoardBase)

export default BoardModel

BoardModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
BoardModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
BoardModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
BoardModel.hasMany("boardColumns")
BoardModel.hasMany("taskBoards")
